module.exports = __webpack_public_path__ + "img/rt_asahiyama_zoo.3ca543bd.jpg";